export default __webpack_public_path__ + "static/map-james-martin-444491c455a596c7373aeeedc0f975a0.png";